(ns shared.core.components.icon
  (:require [shared.core.components.interactive :as interactive]
            [shared.core.style :as style]
            [shared.core.util :as util]
            [camel-snake-kebab.core :as csk]
            [shared.core.reactive :as re]
            [shared.core.components.theme :as theme]
            [shared.core.components.tooltip :as tooltip]
            [clojure.string :as s]))

(defn material-icon [{:keys [id icon-type style on-click class-name dark-style]}]
  [theme/theme
   :i {:id id
       :style (merge {:font-size 20}
                     (when on-click
                       {:cursor :pointer})
                     style)
       :theme (style/dark-style dark-style)
       :class-name (str "material-icons"
                        (when class-name (str " " class-name)))
       :on-click on-click}
   (csk/->snake_case icon-type)])

(defn material-icon-tooltip [{:keys [icon-type icon-style icon-id on-click disabled? dark-icon-style] :as args}]
  [tooltip/tooltip (assoc args :target-content [theme/theme
                                                material-icon
                                                {:id icon-id
                                                 :icon-type icon-type
                                                 :style (merge {:color (style/color :on-background :base)}
                                                               (when (and on-click (not disabled?))
                                                                 {:cursor :pointer})
                                                               icon-style
                                                               (when disabled?
                                                                 {:opacity 0.7
                                                                  :cursor :default}))
                                                 :theme (style/dark-style (merge {:color (style/dark-color :on-surface :base)}
                                                                                 dark-icon-style))
                                                 :on-click (when-not disabled? on-click)}])])

(defn info-tooltip [{:keys [icon-style] :as args}]
  [material-icon-tooltip (assoc args :icon-type :info
                                     :icon-style (merge {:cursor :help}
                                                        icon-style))])

(defn copy-icon-tooltip [{:keys [tooltip-content icon-style copy-text]
                          :or {tooltip-content "Copy"}
                          :as args}]
  [material-icon-tooltip (assoc args :tooltip-content tooltip-content
                                     :icon-type :content-copy
                                     :icon-style (merge {:cursor :pointer}
                                                        icon-style)
                                     :on-click #(re/dispatch-sync [:core/copy-to-clipboard
                                                                   (or copy-text tooltip-content)
                                                                   {:notify? true}]))])

(defn action-material-icon [{:keys [icon-type on-click style dark-style icon-style disabled?]}]
  (let [icon-style (merge {:color :inherit
                           :font-size 18}
                          icon-style)
        container-size (try
                         (js/Math.round (* (util/parse-int (:font-size icon-style)) 1.6))
                         (catch :default _ 30))]
    [theme/theme
     interactive/interactive
     :div {:style (merge {:background-color (style/color :white :base)
                          :color (style/color :gray :base)
                          :display :flex
                          :align-items :center
                          :justify-content :center
                          :transition "0.2s"
                          :height container-size
                          :width container-size}
                         style
                         (when disabled?
                           {:opacity 0.7}))
           :theme (style/dark-style (merge {:background-color (style/dark-color :on-background :base)
                                            :color (style/dark-color :surface :base)}
                                           dark-style))
           :hover-style (when-not disabled?
                          {:background-color (style/color :gray :base)
                           :color (style/color :white :base)
                           :cursor :pointer})
           :on-click (when-not disabled? on-click)}
     [material-icon {:icon-type icon-type
                     :style icon-style}]]))

(defn material-icon-label [{:keys [icon-type icon-style label label-style tooltip-config style dark-icon-style
                                   dark-label-style] :as args}]
  [:div {:style (merge {:display :flex
                        :align-items :center}
                       style)}
   [theme/theme
    material-icon {:icon-type icon-type
                   :style (merge {:color (style/color :gray :base)
                                  :font-size 16
                                  :flex "0 0 auto"}
                                 icon-style)
                   :theme (style/dark-style (merge {:color (style/color :on-surface :base)}
                                                   dark-icon-style))}]
   (into [theme/theme
          :span {:style (merge {:color (style/color :gray :base)
                                :font-size 15
                                :line-height 1.3
                                :margin-left 8}
                               label-style)
                 :theme (style/dark-style (merge {:color (style/dark-color :on-surface :base)}
                                                 dark-label-style))}]
         [(if (:tooltip args)
            [tooltip/tooltip (merge {:tooltip-content (:tooltip args)
                                     :target-content [:span label]}
                                    tooltip-config)]
            label)])])

(defn phosphor-icon [{:keys [id icon-type style on-click extra-classes dark-style weight]}]
  (let [class-name (->> ["ph" icon-type weight]
                        (filter identity)
                        (map #(try
                                (let [class-string (s/lower-case (csk/->kebab-case-string %))]
                                  (if (or (s/starts-with? class-string "ph-") (= class-string "ph"))
                                    class-string
                                    (str "ph-" class-string)))
                                (catch :default _
                                  nil)))
                        (filter identity)
                        (concat extra-classes)
                        (s/join " "))]
    [theme/theme
     :i {:id id
         :style (merge {:font-size 20}
                       (when on-click
                         {:cursor :pointer})
                       style)
         :theme (style/dark-style dark-style)
         :class-name class-name
         :on-click on-click}]))
